export class BatchNew {
  jobNumber: string = '';
  name: string = '';
  description: string = '';
  organizationId: string | null = '';
}
